// @ts-nocheck
import useAccount from "classes/Accounts/hooks/useAccount";
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";

const AccountContext = createContext();

const AccountProvider = ({ children }) => {
	const accountObj = useAccount();
	const [userOrAdmin, setUserOrAdmin] = useState("");
	const { data, error, isLoading } = useQuery(
		["Account", "UserInfo", accountObj.account.companyId],
		() => accountObj.fetchInfos(!accountObj.account.isTemp),
		{ refetchOnWindowFocus: false }
	);

	useEffect(() => {
		let isMounted = true;
		if (data && !isLoading && isMounted) {
			const settings = accountObj.getSettings();
			accountObj.setAccount({
				...accountObj.account,
				...data.infos,
				settings: settings,
				role: data.role,
				rights: data.rights,
				infos: data.infos,
			});
		}
		return () => {
			isMounted = false;
		};
	}, [data]);

	const value = useMemo(
		() => ({ accountObj, userOrAdmin, setUserOrAdmin }),
		[accountObj, userOrAdmin]
	);

	return (
		<AccountContext.Provider value={value}>
			{children}
		</AccountContext.Provider>
	);
};

export function useAccountContext() {
	return useContext(AccountContext);
}

export { AccountContext, AccountProvider };
